<nav
  tourAnchor="bem-vindo-menu"
  class="sidebar"
  [ngClass]="{
    'sidebar--isClosed': isClosed,
    'sidebar--menu-scroll': isMenuScrollable
  }"
>
  <div
    class="sidebar__container-logo">
    <img 
      [src]="isClosed ? 'assets/logos/agger/aggilizador-detalhe-branco.png' : 'assets/logos/agger/logo-aggilizador-txt-white.png'" 
      alt="Logo novo aggilizador"
      routerLink="/"
    >
  </div>

  <ul class="sidebar__menu" #menu>
    @for (item of menuList; track $index) {
        <li class="sidebar__item" *showIfAuthorized="item.showIfAuthorizedName">
          <div class="sidebar__link"
            [tourAnchor]="item.tourAnchor"
            [ngClass]="{'sidebar__link--isActive': router.url.includes(item.url) || tourStepsService?.currentAnchor() === item.tourAnchor}"
            [routerLink]="item.url"
            (click)="item.subMenu ? openSubmenu(item) : null"
            [gaEvent]="item.gaEvent"
            [matTooltip]="isClosed ? item.txt : '' "
            matTooltipPosition="right"
          >
            <div class="sidebar__link-content">
              <ng-icon [name]="item.icon" size="24px"></ng-icon>
              @if (!isClosed) {
                <span class="text-nowrap" @fadeInOut>
                  {{item.txt}}
                </span>
              }
            </div>

            @if (item.subMenu && !isClosed) {
              <ng-icon name="heroChevronDown" size="20px" [ngStyle]="{'transform': item.isOpen ? 'rotate(180deg)' : ''}" @fadeInOut></ng-icon>
            }
          </div>

          @if (item.subMenu && item.isOpen) {
            <ul class="sidebar__submenu" @fadeInOut>
              @for (subitem of item.subMenu; track $index) {
                <li
                  class="sidebar__submenu-item"
                  [ngClass]="{'sidebar__link--isActive': router.url.includes(subitem.url)}"
                  [routerLink]="subitem.url"
                  *showIfAuthorized="subitem.showIfAuthorizedName"
                  [gaEvent]="subitem.gaEvent"
                >
                  <ng-icon [name]="subitem.icon" size="16px"></ng-icon>

                  @if (!isClosed) {
                    <span class="text-nowrap" @fadeInOut>
                      {{subitem.txt}}
                    </span>
                  }
                </li>
              }
            </ul>
          }
        </li>
      }
  </ul>

  <div class="sidebar__footer">
    <button class="sidebar__expand-action transition-transform" (click)="changeOpenSidebar()" [ngClass]="!isClosed ? 'sidebar__expand-action--not-closed' : ''">
      <mat-icon svgIcon="chevron-left" [style]="{'transform': isClosed ? 'rotate(180deg)' : '' }"></mat-icon>
      @if (!isClosed) {
        <span class="text-nowrap">
          Minimizar menu
        </span>
      }
    </button>
  </div>
</nav>

@if (tourStepsService.currentAnchor() === 'bem-vindo-menu') {
  <div class="backdrop-interaction" (click)="closeTour()"></div>
  <div class="backdrop-container"></div>
  <div class="backdrop" (click)="closeTour()"></div>
}
 